import https from "https";
import { HttpsProxyAgent } from "https-proxy-agent";
import { AxiosRequestConfig } from "axios";

let agent: https.Agent;

export const COMMON_AGENT_CONFIG = {
  keepAlive: true,
  maxSockets: 50,
  rejectUnauthorized: true,
};

export function useProxy() {
  const proxyAddress = process.env.HTTPS_PROXY || process.env.HTTP_PROXY;

  if (!proxyAddress || typeof proxyAddress !== "string") {
    return false;
  }

  const proxy = new URL(proxyAddress);

  if (!proxy.hostname) {
    return false;
  }

  return {
    hostname: proxy.hostname,
    port: proxy.port,
    protocol: proxy.protocol,
  };
}

export default function configureHttpAgent() {
  if (!agent) {
    const proxy = useProxy();

    if (proxy) {
      agent = new HttpsProxyAgent({ ...proxy, ...COMMON_AGENT_CONFIG });
    } else {
      agent = new https.Agent({ ...COMMON_AGENT_CONFIG });
    }
  }

  return agent;
}

export const requestOptions: AxiosRequestConfig = {
  httpsAgent: configureHttpAgent(),
  proxy: false,
};

export const httpAgentConfig = {
  requestOptions,
  configureHttpAgent,
  default: configureHttpAgent,
  useProxy,
  COMMON_AGENT_CONFIG,
};
